import { render } from "./danyuan.vue?vue&type=template&id=5db5bc08&scoped=true"
import script from "./danyuan.vue?vue&type=script&lang=js"
export * from "./danyuan.vue?vue&type=script&lang=js"

import "./danyuan.vue?vue&type=style&index=0&id=5db5bc08&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\盘龙山陵园\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db5bc08"]])

export default __exports__